import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Email from '@material-ui/icons/Email';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useStyles } from '../../views/master-sheet-styles';
import AddRepairDialog from '../Repairs/AddRepairDialog';
import RepairDialog from '../Repairs/RepairModal';
import MasterSheetRepairsCheckPhotos from '../Repairs/RepairsCheckPhotosDialog';
import { Show } from 'components/Show';
import { maskDate } from '../../utils/maskDate';
import { getAddContractorsBlocked } from '../../utils/getAddContractorsBlocked';
import { EmailManagementDialog } from '../EmailManagementDialog';
import InfoDialog from 'components/InfoDialog';

const styles = makeStyles({
  boxTitlePhases: {
    background: '#f2f2f2',
    borderRadius: '5px',
    boxShadow:
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
  },
  titlePhases: {
    fontWeight: 'bold',
  },
  accordion: {
    marginBottom: '10px',
    borderRadius: '5px !important',
    boxShadow:
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    '&:before': {
      display: 'none',
    },
  },
  value: {
    fontSize: '17px',
  },
  label: {
    fontSize: '12px',
  },
  title: {
    fontSize: '17px',
    fontWeight: 'bold',
  },
});

interface MobileRepairsViewProps {
  logic: any;
}

export const MobileRepairsView: React.FC<MobileRepairsViewProps> = ({
  logic,
}) => {
  const classes = useStyles();
  const innerStyles = styles();

  const {
    repairs,
    poReleasedInfoOpen,
    setPoReleasedInfoOpen,
    showRepairModal,
    setShowRepairModal,
    showAddRepairModal,
    setShowAddRepairModal,
    repair,
    setRepair,
    openCheckPhotosModal,
    setOpenCheckPhotosModal,
    isShowView,
    title,
    photos,
    loadingBuilderSupervisorEmail,
    hasPhotos,
    setHasPhotos,
    emailManagementOpen,
    setEmailManagementOpen,
    emailRepairId,
    setEmailRepairId,
    scroll,
    subdivisionBuilderSupervisors,
    canSendEmailClient,
    canCreateRepair,
    handleSendMail,
    onAddRepair,
    handleUploadClick,
    getRepairButtonText,
    handleRepairActionClick,
    theJob,
    refreshRepairs,
    setJob,
  } = logic;

  return (
    <Box px={1.5}>
      <Box display="flex" justifyContent="flex-end" my={1.5}>
        {canCreateRepair && (
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.buttonRepairs}
            onClick={() => setShowAddRepairModal(true)}
          >
            Add Repair
          </Button>
        )}
      </Box>
      <div ref={scroll} />
      <Box width="100%">
        {repairs.map((repair, i) => {
          const { description, repairDate, poTotal, text, hasPhotos } = repair;

          const isAddContractorsBlocked = getAddContractorsBlocked(repair);
          const buttonText = getRepairButtonText(repair);

          return (
            <Accordion className={innerStyles.accordion} key={i}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" justifyContent="space-between" width="100%">
                  <Box display="flex" gridGap={2}>
                    <Box>
                      <Typography className={innerStyles.label}>
                        Service Type
                      </Typography>
                      <Typography className={innerStyles.value}>
                        {description}
                      </Typography>
                    </Box>
                    <Show condition={isAddContractorsBlocked}>
                      <IconButton
                        onClick={event => {
                          event.stopPropagation();
                          setPoReleasedInfoOpen(true);
                        }}
                      >
                        <InfoIcon color="error" />
                      </IconButton>
                    </Show>
                  </Box>

                  <Box>
                    <Typography className={innerStyles.label}>Date</Typography>
                    <Typography className={innerStyles.value}>
                      {maskDate(repairDate)}
                    </Typography>
                  </Box>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Box width="100%">
                  <Box>
                    <Typography className={innerStyles.label}>
                      PO Total $
                    </Typography>
                    <Typography className={innerStyles.value}>
                      {poTotal}
                    </Typography>
                  </Box>
                  <Show condition={canSendEmailClient}>
                    <Box mt={2}>
                      <Typography className={innerStyles.label}>
                        Email Management
                      </Typography>

                      <Typography className={classes.bigText}>
                        <Box width="100%">
                          <Typography className={classes.bigText}>
                            <Show condition={canSendEmailClient}>
                              <IconButton
                                disabled={loadingBuilderSupervisorEmail}
                                onClick={async () => {
                                  setRepair(repair);
                                  setEmailRepairId(repair?.id);
                                  setHasPhotos(hasPhotos);
                                  setEmailManagementOpen(true);
                                }}
                              >
                                {repair?.id === emailRepairId &&
                                loadingBuilderSupervisorEmail ? (
                                  <CircularProgress size={30} />
                                ) : (
                                  <Email className={classes.iconsUpload} />
                                )}
                              </IconButton>
                            </Show>
                          </Typography>
                        </Box>
                      </Typography>
                    </Box>
                  </Show>
                  <Box borderBottom="1px solid black" width="100%" mt={2}>
                    <Typography className={innerStyles.title}>
                      Description
                    </Typography>
                  </Box>
                  <Box>
                    <Typography className={innerStyles.value}>
                      {text}
                    </Typography>
                  </Box>
                  <Box width="100%" display="flex" my={1}>
                    {hasPhotos ? (
                      <Box>
                        <IconButton onClick={() => handleUploadClick(repair)}>
                          <CloudUploadIcon className={classes.iconsUpload} />
                        </IconButton>
                      </Box>
                    ) : null}
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      className={classes.buttonRepairs}
                      onClick={() => handleRepairActionClick(repair)}
                    >
                      {buttonText}
                    </Button>
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
      <AddRepairDialog
        open={showAddRepairModal}
        subdivisionBuilderSupervisors={subdivisionBuilderSupervisors}
        theJob={theJob}
        onClose={() => setShowAddRepairModal(false)}
        onAdd={onAddRepair}
        isMobile
      />
      {showRepairModal && (
        <RepairDialog
          open
          isShowView={isShowView}
          subdivisionBuilderSupervisors={subdivisionBuilderSupervisors}
          repair={repair}
          theJob={theJob}
          handleClose={() => setShowRepairModal(false)}
          handleConfirm={refreshRepairs}
          setJob={setJob}
        />
      )}
      <MasterSheetRepairsCheckPhotos
        photos={photos}
        title={title}
        handleClose={() => setOpenCheckPhotosModal(false)}
        open={openCheckPhotosModal}
      />
      <EmailManagementDialog
        hasPhotos={hasPhotos}
        emailManagementOpen={emailManagementOpen}
        loadingBuilderSupervisorEmail={loadingBuilderSupervisorEmail}
        emailRepairId={emailRepairId}
        handleSendMail={handleSendMail}
        handleUploadClick={() => handleUploadClick(repair)}
        handleClose={() => {
          setEmailManagementOpen(false);
          setHasPhotos(false);
          setEmailRepairId(null);
        }}
      />
      <InfoDialog
        handleClose={() => setPoReleasedInfoOpen(false)}
        open={poReleasedInfoOpen}
        content="Contractor is not able to be assigned until the PO has been released."
      />
    </Box>
  );
};

export default MobileRepairsView;
